// import axiosInstance from '../../config'; // pre-configured axios instance

// export const copierPauseService = async (token, data) => {
//   try {
//     const response = await axiosInstance.post(
//       '/copier/pause_copier',
//       data,

//       {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//       }
//     );



//     return {
//       data: response.data,
//       status: response.status,
//     };

//   } catch (error) {

//     return {
//       error: true,
//       message: error.response?.data || error.message,
//       status: error.response?.status || 500
//     };
//   }
// };


import axiosInstance from '../../config'; //axios instance with pre-configuration

export const copierPauseService = async (token, data) => {

    try {

        const response = await axiosInstance.post(

            '/copier/pause_copier',

            data,

            {

                headers: {

                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",

                },

            }

        );



        return {

            data: response.data,

            status: response.status,

        };

    }
    catch (error) {



        return {

            error: true,

            message: error.response?.data || error.message,

            status: error.response?.status || 500

        };

    }

};